import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {HarlequinSlideShowFSIntroView} from "./HarlequinSlideShowFSIntroView";

/**
 * Created by jonas on 2020-03-23.
 *
 * This wrapper is needed because GameModeTransitionView extends BseView. That in turn is not compatible with
 * StageLayer, because both of them has a different signature onResize function.
 *
 * And StageLayer is the way of the future, bot BaseView.
 */

export class HarlequinTransitionViewWrapper extends BaseView implements GameModeTransitionView {
    private _introView:HarlequinSlideShowFSIntroView;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._introView = new HarlequinSlideShowFSIntroView();
    }

    prepare(data:ParsedServerData):void {
        this._introView.prepare(data);
    }

    getStartAnimation(prepareToEnterModeCallback:() => void, completeCallback:() => void):TimelineLite {
        return this._introView.getStartAnimation(prepareToEnterModeCallback, completeCallback);
    }

    getEndAnimation():TimelineLite {
        return this._introView.getEndAnimation();
    }

}